// SEO-friendly auction URL slugs.
// Format: <slugified-title-and-grade>-<uuid>
//   e.g. pokemon-charizard-psa-10-9f8a1b2c-3d4e-5f60-8a9b-abcdef012345
// The UUID is always the last 36 chars, letting us extract the ID reliably
// even if the title portion is malformed by a copy-paste.

const UUID_TAIL = /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;

function slugifyText(input: string): string {
  return input
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "") // strip diacritics
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
}

export function buildAuctionSlug(input: {
  id: string;
  title?: string | null;
  grading_company?: string | null;
  grade?: string | null;
}): string {
  const parts = [input.title ?? "", input.grading_company ?? "", input.grade ?? ""]
    .filter(Boolean)
    .join(" ");
  const text = slugifyText(parts) || "auction";
  return `${text}-${input.id}`;
}

export function extractIdFromSlug(slug: string): string | null {
  const m = UUID_TAIL.exec(slug);
  return m ? m[1].toLowerCase() : null;
}

export function isCanonicalSlug(slug: string, expected: string): boolean {
  return slug === expected;
}
